import { useMotionValueEvent, useScroll } from "framer-motion"
import { RefCallback, useCallback, useRef, useState } from "react"

type UseScrollOptions = Parameters<typeof useScroll>[0]
type UseScrollAppOptions = UseScrollOptions

// A wrapper around framer-motion's useScroll that automatically sets
// the container to be the main scrollable area of the app.
export function useIsScrolled(options?: UseScrollAppOptions) {
  const [isScrolled, setIsScrolled] = useState(false)
  // Using tick to force a re-render when the ref changes.
  const [_, setTick] = useState(0)
  const containerRef = useRef<HTMLElement | null>(null)

  const { scrollY } = useScroll({
    offset: ["start end", "end start"],
    container: containerRef,
    ...options
  })

  useMotionValueEvent(scrollY, "change", (latest) => {
    const nextIsScrolled = latest > 0
    if (nextIsScrolled !== isScrolled) setIsScrolled(nextIsScrolled)
  })

  const setContainerRef = useCallback<RefCallback<HTMLElement>>((node) => {
    // Update the ref's current value
    containerRef.current = node
    setTick((tick) => tick + 1)
  }, [])

  return [isScrolled, setContainerRef] as const
}
